/**
 * List all the available data sources.
 * When several sources are requested, the priority order is the order of the enum.
 */
var DataSources;
(function (DataSources) {
    DataSources[DataSources["aggregated_measurement"] = 0] = "aggregated_measurement";
    DataSources[DataSources["measurement"] = 1] = "measurement";
    DataSources[DataSources["spatialized_weather"] = 2] = "spatialized_weather";
    DataSources[DataSources["spatialized_current_weather"] = 3] = "spatialized_current_weather";
    DataSources[DataSources["agro_measurement"] = 4] = "agro_measurement";
    DataSources[DataSources["forecast"] = 5] = "forecast";
    DataSources[DataSources["climate_normal"] = 6] = "climate_normal";
    DataSources[DataSources["user_measurement_report"] = 7] = "user_measurement_report";
    DataSources[DataSources["past_forecast"] = 8] = "past_forecast";
    DataSources[DataSources["computed_metric"] = 9] = "computed_metric";
    DataSources[DataSources["point_agro_measurement"] = 10] = "point_agro_measurement";
    DataSources[DataSources["ephemeral_weather"] = 11] = "ephemeral_weather";
    DataSources[DataSources["vision_weather"] = 12] = "vision_weather";
    DataSources[DataSources["vision_agro"] = 13] = "vision_agro";
    DataSources[DataSources["weedriq"] = 14] = "weedriq";
})(DataSources || (DataSources = {}));
const forecastSources = [DataSources.forecast, DataSources.weedriq];
export const isForecastDataSource = (source) => forecastSources.includes(source);
const weatherSources = [
    DataSources.spatialized_current_weather,
    DataSources.spatialized_weather,
    DataSources.ephemeral_weather
];
export const isWeatherDataSource = (source) => weatherSources.includes(source);
const spatializedWeatherSources = [
    DataSources.spatialized_current_weather,
    DataSources.spatialized_weather,
    /**
     * Not a mistake
     * This what placed inside this category so those specific forecasts aren't ignored when computing the history card aggregates
     * and so they're displayed under the "spatialized weather" label on tooltips
     */
    DataSources.past_forecast
];
export const isSpatializedWeatherDataSource = (source) => spatializedWeatherSources.includes(source);
const measurementSources = [
    DataSources.aggregated_measurement,
    DataSources.measurement,
    DataSources.agro_measurement,
    DataSources.point_agro_measurement,
    DataSources.computed_metric
];
export const isMeasurementDataSource = (source) => measurementSources.includes(source);
const userReportSources = [DataSources.user_measurement_report];
export const isUserReportDataSource = (source) => userReportSources.includes(source);
const meteoVisionSources = [DataSources.vision_weather, DataSources.vision_agro];
export const isMeteoVisionDataSource = (source) => meteoVisionSources.includes(source);
export default DataSources;
